/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Pure Patina homepage conversion review — unpublished theme only.
document.addEventListener('DOMContentLoaded', function () {
  if (document.body.classList.contains('template-index')) {
    var availableLink = document.querySelector('.section--featured_available .section__link-link');
    if (availableLink) {
      availableLink.classList.remove('link', 'link--arrow');
      availableLink.classList.add('c-btn', 'c-btn--primary', 'pp-available-cta');
    }
    var style = document.createElement('style');
    style.id = 'pp-homepage-conversion-styles';
    style.textContent = '.section--featured_available .section__link{margin-top:28px}.section--featured_available .pp-available-cta{display:inline-flex;align-items:center;justify-content:center;min-width:260px;padding-left:30px;padding-right:30px;font-weight:700;letter-spacing:.06em}';
    document.head.appendChild(style);
  }
});
